import { Injectable, inject } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { patchState } from '@res/ng-repository';
import { FilterModel } from 'ag-grid-community';
import { LosserFirestoreService } from '../../services/losser.firestore.service';
import { LosserActions } from './losser.action';
import { LosserStateModel } from './losser.store';

@State<LosserStateModel>({
  name: 'lossers',
  defaults: {
    lossers: [],
    isSubscribed: false,
    isLoading: false,
    sort: [],
  },
})
@Injectable()
export class LosserState {
  private lossersService = inject(LosserFirestoreService);
  // private userState = inject(UserState);
  // private dbUser = inject(OrmService).userCollection;
  // private authService = inject(Auth);
  // private store = inject(Store);

  @Action(LosserActions.GetAllLossers)
  async getAllLossers(ctx: StateContext<LosserStateModel>) {
    ctx.patchState({ isLoading: true });
    const lossers = await this.lossersService.GetAll();
    ctx.patchState({
      lossers: lossers.map(({ data, ref }) => ({ ...data, ref })),
      isLoading: false,
    });
  }

  @Action(LosserActions.UpdateLosser)
  async updateLosser(ctx: StateContext<LosserStateModel>, { losserData, ref }: LosserActions.UpdateLosser) {
    await this.lossersService.Update(ref, losserData);
  }

  @Action(LosserActions.UpdateLosserResult)
  updateLosserResult(ctx: StateContext<LosserStateModel>, { data }: LosserActions.UpdateLosserResult) {
    patchState<LosserStateModel>(ctx, 'lossers', data);
  }

  @Action(LosserActions.PaginateQueryLosser)
  async queryLosser(
    ctx: StateContext<LosserStateModel>,
    { request, isResetAfterFilterOrSort }: LosserActions.PaginateQueryLosser,
  ) {
    const state = ctx.getState();
    // if (request.filterModel && (request.filterModel as FilterModel)['userId']) {
    //   (request.filterModel as FilterModel)['userId']['values'] = (request.filterModel as FilterModel)[
    //     'userId'
    //   ].values.map(
    //     (v: string) => this.store.selectSnapshot(UserState.users).find((user) => user.companyName === v)?.ref
    //   );
    // }
    // if (userId) {
    //   request.filterModel = {
    //     userId: { filter: this.dbUser.ref(this.dbUser.id(userId)), type: 'equals' },
    //     ...request.filterModel,
    //   };
    // }

    ctx.patchState({ isLoading: true });
    const { runs, direction } = this.lossersService.SetQuery({
      ...request,
      count: state.lossers.length,
      data: state.lossers,
    });
    if (isResetAfterFilterOrSort) {
      const trCound = state.lossers.length;
      state.lossers = [];
      state.lossers.length = trCound;
    }
    if (JSON.stringify(state.filter) !== JSON.stringify(request.filterModel)) {
      ctx.patchState({ filter: request?.filterModel });

      state.lossers = [];
      state.lossers.length = await this.lossersService.GetBuildedCount(runs);
    }
    if (state.lossers.length !== 0) {
      runs.push(...this.lossersService.SetLimit({ ...request, count: state.lossers.length, data: [] }));
      ctx.patchState({ sort: request?.sortModel });

      if (!runs.some((x) => x.type === 'limit')) {
        throw new Error('No limit');
      }
      const lossers = await this.lossersService.GetBuildedData(runs);
      ctx.patchState({ filter: request?.filterModel });

      if (direction === 'asc') {
        lossers.reverse().forEach(
          ({ data, ref }, i) =>
            (state.lossers[i + (request?.startRow ?? 0)] = {
              ...data,
              ref,
            }),
        );
      } else {
        lossers.forEach(
          ({ data, ref }, i) =>
            (state.lossers[i + (request?.startRow ?? 0)] = {
              ...data,
              ref,
            }),
        );
      }
    }

    ctx.patchState({ isLoading: false, lossers: state.lossers });
  }

  @Action(LosserActions.LosserError)
  lossersError(ctx: StateContext<LosserStateModel>, { error }: LosserActions.LosserError) {
    console.error({ error });
    // await this.lossersService.Update(id, lossersData);
  }

  @Action(LosserActions.DeleteLossers)
  async deletetlossers(ctx: StateContext<LosserStateModel>, { refs }: LosserActions.DeleteLossers) {
    await this.lossersService.BatchDelete(refs);
  }

  @Action(LosserActions.GetSumsCountOf)
  public async getCountOf(
    ctx: StateContext<LosserStateModel>,
    { fields, timePeriod, filterModel }: LosserActions.GetSumsCountOf,
  ) {
    const query = {
      filterModel: {},
      startRow: undefined,
      endRow: undefined,
      sortModel: [],
      data: [],
      count: 0,
    };
    if (timePeriod.dateFrom && timePeriod.dateTo) {
      (query.filterModel as FilterModel)['createdAt'] = {
        colId: 'createdAt',
        type: 'inRange',
        filter: timePeriod.dateFrom,
        filterTo: timePeriod.dateTo,
      };
    }
    // if (userId) {
    //   filterModel = { userId: { filter: this.dbUser.ref(this.dbUser.id(userId)), type: 'equals' }, ...filterModel };
    // }
    for (const [fieldKey, fieldFilter] of Object.entries(filterModel ?? {})) {
      (query.filterModel as FilterModel)[fieldKey] = fieldFilter;
    }
    (query.filterModel as FilterModel)['paymentResult'] = {
      colId: 'paymentResult',
      type: 'equals',
      filter: 'Successful',
    };

    // query.filterModel.paymentResult = { colId: 'paymentResult', type: 'equals', filter: 'Successful' };
    const extraQuerry = this.lossersService.SetQuery(query);
    const querrys: { [key: string]: { sum: number; count: number } } = {};
    for (const field of fields) {
      querrys[field.sumId] = {
        sum: await this.lossersService.QuerySumByCreationDate(field.sumId, extraQuerry.runs),
        count: await this.lossersService.QueryCountByCreationDate(field.countId, field.countValue, extraQuerry.runs),
      };
    }
    ctx.patchState({ sums: querrys });
  }

  @Selector()
  static lossers(state: LosserStateModel) {
    return state.lossers;
  }
  @Selector()
  static lossersCount(state: LosserStateModel) {
    return state.lossers.length;
  }

  @Selector()
  static sums(state: LosserStateModel) {
    return state.sums;
  }

  @Selector()
  static sumsByParams(state: LosserStateModel) {
    return (field: string) => state?.sums?.[field];
  }

  @Selector()
  static lossersState(state: LosserStateModel) {
    return state;
  }
}
